<template>
  <form class="clientForm" v-if="client || isAddClient">
    <form-group v-if="isAddClient">
      <field name="Name" :value="client.name" v-model="client.name"/>
    </form-group>
    <form-group>
      <field name="Cost Per Creative" :value="client.create_cost" type="number" v-model="client.create_cost"/>
    </form-group>
    <form-group>
      <field name="Cost Per Render" :value="client.render_cost" type="number" v-model="client.render_cost"/>
    </form-group>
    <form-group>
      <field name="Cost Per Download" :value="client.download_cost" type="number" v-model="client.download_cost"/>
    </form-group>
    <form-group>
      <field name="Cost Per Video Download" :value="client.download_video_cost" type="number" v-model="client.download_video_cost"/>
    </form-group>
    <form-group>
      <field name="Cost Per AdTag Created" :value="client.adtag_create_cost" type="number" v-model="client.adtag_create_cost"/>
    </form-group>
    <form-group>
      <field name="Cost Per AdTag Refreshed" :value="client.adtag_refresh_cost" type="number" v-model="client.adtag_refresh_cost"/>
    </form-group>
    <form-group>
      <field name="Cost Per Video AdTag Created" :value="client.adtag_video_create_cost" type="number" v-model="client.adtag_video_create_cost"/>
    </form-group>
    <form-group>
      <dropdown name="Currency" :options="currency.options" :current="client.currency"  v-model="client.currency"/>
    </form-group>
    <form-group>
      <field name="VAT Rate" :value="client.vat_rate" type="number" v-model="client.vat_rate"/>
    </form-group>
    <heading type="h2">Manage Users</heading>
    <list v-model="client.users" :data="this.users" :currentIds="client.users" />
    <form-group>
      <button-cta :onClick="submit">Save</button-cta>
    </form-group>
  </form>
</template>

<script>
import FormGroup from '@/components/Form/FormGroup/form-group'
import Dropdown from '@/components/Form/Dropdown/dropdown'
import Field from '@/components/Form/Field/field'
import RadioButton from '@/components/Form/RadioButton/radio-button'
import ButtonCta from '@/components/Button/button'
import Heading from '@/components/Heading/heading'
import List from '@/components/List/list'
import {userMixin} from '@/mixins/userMixin'

export default {
  name: 'ClientForm',
  mixins: [userMixin],
  components: {
    FormGroup,
    Dropdown,
    Field,
    RadioButton,
    ButtonCta,
    Heading,
    List
  },
  props: {
    client: Object,
    submit: Function,
    isAddClient: Boolean
  },
  created () {
    this.getUsers().then(() => {
      this.$emit('loading', false)
    })
  },
  data: () => ({
    loading: false,
    currency: {
      options: [
        {
          name: '$ Dollar',
          value: 'usd'
        },
        {
          name: '£ Pound',
          value: 'gbp'
        },
        {
          name: '€ Euro',
          value: 'eur'
        }
      ]
    }
  })
}
</script>

<style lang="scss">
    @import "./client-form";
</style>



// WEBPACK FOOTER //
// src/components/ClientForm/client-form.vue